import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { User } from '@commons/models/domain/User';
import { UserHttpService } from '@shared/services-http/user-http.service';
import { LanguageService } from '@shared/services/language.service';
import { LanguageCode } from '@shared/view-models/language.viewmodel';

@Component({
  selector: 'app-handover-add',
  templateUrl: './handover-add.component.html',
  styleUrls: ['./handover-add.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoverAddComponent {

  private readonly youtubeUrls = {
    [LanguageCode.PL]: 'https://www.youtube.com/embed/93snQe9ITFk?si=mZL5AN4tolyPa0Y8',
    [LanguageCode.EN]: 'https://www.youtube.com/embed/0dZ6K5kw8Ws?si=WiKQlY1pOwHw2kFI%22',
    [LanguageCode.PT]: 'https://www.youtube.com/embed/0dZ6K5kw8Ws?si=WiKQlY1pOwHw2kFI%22',
  };

  public emailIsSended: boolean;
  public youtubeSrc: SafeResourceUrl;

  private get user(): User | undefined {
    return this.userHttpService?.userViewModel?.user;
  }

  constructor(
    private userHttpService: UserHttpService,
    private languageService: LanguageService,
    private domSanitizer: DomSanitizer,
  ) {
    const url = this.youtubeUrls[this.languageService.current];
    this.youtubeSrc = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public sendEmail(): void {
    const email = "rozwoj@tekom.pl";
    const subject = "Elektroniczne protokoły przekazania pojazdu";
    const msgBody = `Jestem zainteresowany funkcją elektronicznych protokołów. Proszę o kontakt: ${ this.user?.Email }`;
    this.emailIsSended = true;
    window.open(`mailto:${email}?subject=${subject}&body=${msgBody}`);
  }
}
